import { setupResourceStore } from '@/utils'
import Shipment from '@/resources/Shipment';

const resource = setupResourceStore(Shipment)


const state = {
  ...resource.state
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};